module.exports = __webpack_public_path__ + "img/DOC.5fad6b5.svg";